const PaymentTypes = {
  KBZ: "KBZPay",
  CREDIT: "credit card",
  COD: "Cash on delivery",
};
export default PaymentTypes;
